import React, { createContext, useContext, useState } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from '../components/utils/SmartLink'

// const SurrogateLink = ({ visualType, ...props }) => <Link {...props} />

export const MobileMenuContext = createContext([{ isMenuOpen: false }, () => ({ isMenuOpen: false })])

export const MobileMenuProvider = ({ children }) => {
  const [state, setState] = useState({ isMenuOpen: false })

  return (
    <MobileMenuContext.Provider value={[state, setState]} children={children} />
  )
}

const StylishSection = styled.div`
  padding: 1rem;
  text-align: center;
`

const StylishSectionLabel = styled.div`
  font-size: 2rem;
  padding: .5rem;
  color: ${props => props.theme.mobileMenuSectionTextColor};
`

const StylishMobileLink = styled(Link)`
  padding: 1rem;
  background-color: ${props => props.theme.mobileMenuButtonBackgroundNormal};
  color: ${props => props.theme.mobileMenuButtonTextNormal};
  margin: .5rem;
  display: block;
  text-decoration: none;
  font-size: 1.25rem;
  :active{
    background-color: ${props => props.theme.mobileMenuButtonBackgroundActive};
    color: ${props => props.theme.mobileMenuButtonTextActive};;
  }
`

const MobileNavigation = () => {
  const setState = useContext(MobileMenuContext)[1]
  const sections = useStaticQuery(graphql`
    {
      mobileNavigation:allFile(filter: {name: {eq: "navigationSettings"}}) {
        edges {
          node {
            childMarkdownRemark {
              frontmatter {
                mobileNavigation {
                  sections {
                    label
                    links {
                      href
                      linkLabel
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
    .mobileNavigation
    .edges[0]
    .node
    .childMarkdownRemark
    .frontmatter
    .mobileNavigation
    .sections

  const renderLinks = linksArray => linksArray.map(link => {
    const handleClick = () => {
      setState({
        isMenuOpen: false
      })
    }

    return (
      <div key={link.linkLabel + link.href}>
        <StylishMobileLink to={link.href} onClick={handleClick}>{link.linkLabel}</StylishMobileLink>
      </div>
    )
  })

  const renderSections = sectionArray => sections.map(section => {
    const { label, links } = section
    const renderedLinks = renderLinks(links)
    return (
      <StylishSection key={label} >
        <StylishSectionLabel>{label}</StylishSectionLabel>
        <div>
          { renderedLinks }
        </div>
      </StylishSection>
    )
  })

  return (
    <div>
      {renderSections(sections)}
    </div>
  )
}

const InternalButton = ({ className }) => {
  const [state, setState] = useContext(MobileMenuContext)
  const { isMenuOpen } = state
  const clickHandler = () => {
    setState(currentState => {
      return {
        isMenuOpen: !currentState.isMenuOpen
      }
    })
  }

  const hamburger = (<i className='fas fa-bars' />)
  const close = (<i className='fas fa-times' />)

  return (
    <div className={className} onClick={clickHandler}>
      {isMenuOpen ? close : hamburger}
    </div>
  )
}

export const MobileNavigationButton = styled(InternalButton)`
  padding: .25rem .5rem;
  color: ${props => props.theme.mobileMenuTopButtonTextColorNormal};
  margin-right: .5rem;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  :active{
    color: ${props => props.theme.mobileMenuTopButtonTextColorActive};
  }
`

export const InternalPanel = ({ className }) => {
  const [state] = useContext(MobileMenuContext)

  const { isMenuOpen } = state

  return isMenuOpen ? (
    <div className={className}>
      <MobileNavigation />
    </div>
  ) : null
}

export const MobileNavigationPanel = styled(InternalPanel)`
  position: absolute;
  top: 3.1rem;
  right: 0;
  background: ${props => props.theme.mobileMenuBackgroundColor};
  left: 0;
  bottom: 0;
  padding: 1rem;
  overflow: auto;
  z-index: 100;
  display: none;
  @media screen and (max-width:${props => props.theme.pageBreakPointSmall}) {
    display: block;
  }
`
